import { Typography, Box, useTheme, Checkbox, Stack, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Card, CardHeader, CircularProgress, CardContent, Alert, Chip, TextField, Divider, Autocomplete, Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import React, { useState, useEffect } from "react";
import InfoIcon from '@mui/icons-material/Info';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CallAlertBar from "../../../Layout/Alertbar";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import useProductionTracking from "../../../hooks/useProductionTrackking";
import useGetSONumberListForReelTransfer from "../../../hooks/useGetSONumberListForReelTransfer";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import useGetSONumberWiseLineItemListForReelTransfer from "../../../hooks/useGetSONumberWiseLineItemsForReelTransfer";
import useGetChildRollListBySONumber from "../../../hooks/useGetChildRollListBySONumber";

const ReelTransferProcess = ({ onClose, handleBackWinderMachineEntry, open }) => {


    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [loading, setLoading] = useState(false);
    const { salesOrderNumber, selectedSalesOrderNumber, selectedSalesOrderNumberID, setSalesOrderNumber, setSelectedSalesOrderNumber, setSelectedSalesOrderNumberID, loadSalesOrderNumberByID, ddloading, setddLoading } = useGetSONumberListForReelTransfer(0);
    const { productionTracking, dataloading, setProductionTracking, setdataLoading, loadProductionTrackingBySOAndCRNumber } = useProductionTracking();
    const { lineItemList, selectedLineItem, selectedLineItemID, setLineItemList, setSelectedLineItem, setSelectedLineItemID, loadSalesOrderWiseLineItemBySONumber, lineItemLoading, setLineItemLoading } = useGetSONumberWiseLineItemListForReelTransfer();
    const { childRollList, selectedChildRollID, setChildRollList, setSelectedChildRollID, loadChildRollBasedOnSoNumber, childRollLoading, setChildRollLoading } = useGetChildRollListBySONumber();

    const [operatorList, setOperatorList] = useState([]);
    const [result, setresult] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    //message are 
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const [selectedSetID, setSelectedSetID] = useState();
    const [availableLot, setAvailableLot] = useState([]);
    const [addSetCount, setAddSetCount] = useState(0);


    const DetailRow = ({ label, value }) => (
        <Grid container item xs={12}>
            <Grid item xs={6}>
                <Typography variant="subtitle2" textAlign="left">
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="subtitle2" textAlign="right" fontWeight="bold">
                    {value}
                </Typography>
            </Grid>
        </Grid>
    );


    const callback = () => {
        handleBackWinderMachineEntry();
    };

    // Get Shift Codes
    useEffect(() => {
        if (!isDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
            }
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setOperatorList(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [isDataLoaded]);



    const handleSaveOperator = () => {

        setParentRollMsgOpen(false);
        // validation 
        let isValid = true;
        let validation_msg = '';

        if (selectedSetID === '') {
            validation_msg += 'Please select Set number for duplication process.\n';
            isValid = false;
        }

        if (addSetCount === '') {
            validation_msg += 'Please enter add extra set count.\n';
            isValid = false;
        }


        if (isValid) {
            const SaveData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_user_name: localStorage.getItem('userID'),
                // p_release_no:winderMONumber,
                // p_lot_no:winderMANumber,
                // p_duplicate_set_count:addSetCount,
                // p_selected_set:selectedSetID,
                // p_parent_roll_id:parentRollId,
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_ADD_EXTRA_SET, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setresult(data[0]);

                        if (data[0].result_value == 0) {
                            // Show a notification when the PDF is downloaded successfully
                            toast.success('Additional Set Was Added Successfully.', { position: toast.POSITION.BOTTOM_CENTER });
                            onClose();
                        }
                        else {
                            // Show a notification when the PDF is downloaded successfully
                            toast.success('Unable to Add Extra set value, Kindly check network connection.', { position: toast.POSITION.BOTTOM_CENTER });
                        }


                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
        else {

            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
        }


    };


    const handleEdit = (id_tds, description, line_no) => {       
        let id_line_item = id_tds;
        // loadChildRollBasedOnSoNumber(selectedSalesOrderNumber,line_no)
    };




    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >


            <DialogTitle style={{ backgroundColor: colors.primary[600], color: colors.primary }}>
                <Box display="flex" alignItems="center">
                    <Typography>Production Reel Transfer to Another Line Item</Typography>
                </Box>

            </DialogTitle>
            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                {/* Your modal content here */}


                <Box>

                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Grid container spacing={2} sx={{ width: '100%', p: 1 }} >
                        <Grid item xs={12} sm={12} md={8} lg={12} xl={12}  >

                            <Box marginTop={1}>
                                <Stack direction="row" spacing={4} alignItems="center">
                                    <Box display="flex" alignItems="center">
                                        <Typography variant="subtitle2">Master Reel Size</Typography>
                                        <Chip
                                            label="63.5 X 91"
                                            color="success"
                                            size="small"
                                            sx={{ ml: 1, fontWeight: "bold" }}
                                        />
                                    </Box>

                                    <Box display="flex" alignItems="center">
                                        <Typography variant="subtitle2">Current SO Number</Typography>
                                        <Chip
                                            label="IND0001"
                                            color="success"
                                            size="small"
                                            sx={{ ml: 1, fontWeight: "bold" }}
                                        />
                                    </Box>
                                </Stack>
                            </Box>


                            <Divider sx={{ marginTop: '20px' }} />


                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={2}
                                marginBottom={2}
                            >


                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 4',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Typography variant="h6"> Transfer To SO Number</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 8',
                                        xl: 'span 8',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        freeSolo
                                        options={salesOrderNumber}
                                        value={selectedSalesOrderNumber}
                                        loading={ddloading} // Adds built-in loading support
                                        onChange={(event, newValue) => {
                                            if (typeof newValue === "string") {
                                                setSelectedSalesOrderNumber({ so_number: newValue });
                                                setSelectedSalesOrderNumberID(null);
                                            } else if (newValue) {
                                                setSelectedSalesOrderNumber(newValue);
                                                setSelectedSalesOrderNumberID(newValue.id || null);
                                            } else {
                                                setSelectedSalesOrderNumber(null);
                                                setSelectedSalesOrderNumberID(null);
                                            }
                                        }}
                                        onInputChange={(event, newInputValue) => {
                                            if (newInputValue) {
                                                setSelectedSalesOrderNumber({ so_number: newInputValue });
                                                loadSalesOrderWiseLineItemBySONumber({ so_number: newInputValue });
                                            }
                                        }}
                                        getOptionLabel={(option) => (typeof option === "string" ? option : option?.so_number || "")}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Sales Order Number"
                                                required
                                                variant="outlined"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />

                                </Box>


                            </Box>
                            <Divider sx={{ marginTop: '40px' }} />

                            <Box marginTop={0.5}>
                                <CustomTableContainer colors={colors}>
                                    <TableContainer>
                                        {loading ? (
                                            <SkeletonTableLoader rows={5} columns={6} />
                                        ) : (
                                            <Table>
                                                <TableHead sx={{ height: 10 }}>
                                                    <TableRow>
                                                        
                                                        <TableCell>SNO</TableCell>
                                                        <TableCell>ITEM CODE</TableCell>
                                                        <TableCell>GSM</TableCell>
                                                        <TableCell>WIDTH</TableCell>
                                                        <TableCell>LENGTH</TableCell>
                                                        <TableCell>LINE NO</TableCell>
                                                       

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {lineItemList.map((s) => (
                                                        <React.Fragment key={s.id_indent}>
                                                            <TableRow>
                                                               
                                                                <TableCell>{s.id_indent}</TableCell>
                                                                <TableCell>{s.item_code}</TableCell>
                                                                <TableCell>{s.gsm}</TableCell>
                                                                <TableCell>
                                                                    <span
                                                                        style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                                        onClick={() => handleEdit(s.id_indent, s.so_number, s.line_no)}
                                                                    >
                                                                        {s.width}
                                                                    </span>
                                                                </TableCell>
                                                                <TableCell>{s.length}</TableCell>
                                                                <TableCell>{s.line_no}</TableCell>
                                                                

                                                            </TableRow>
                                                        </React.Fragment>
                                                    ))}

                                                </TableBody>
                                            </Table>
                                        )}
                                    </TableContainer>
                                </CustomTableContainer>
                            </Box>

                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>

            <DialogActions style={{ backgroundColor: colors.primary[400] }}>
                <Box display="flex" justifyContent="flex-end">
                    <Button onClick={handleSaveOperator} size="small" variant="contained" color="secondary">
                        Save
                    </Button>
                    <Button size='small' onClick={onClose} variant="contained" color="secondary" style={{ textTransform: 'none', marginLeft: '10px' }} >
                        Cancel
                    </Button>
                </Box>

            </DialogActions>

        </Dialog>
    );
};
export default ReelTransferProcess;